/* eslint-disable */
import axios from 'axios'
import { getLocalURL } from '../../../scripts/helpers/globale'

export default class ProductGrid {
  constructor(component) {
    this.dom = {
      $component: component,
      $productContainer: component.querySelector('.js-productGrid'),
      $paginationContainer: component.querySelector('.js-pagination'),
      $filters: document.querySelectorAll('.js-filterCheckbox'),
      $labels: document.querySelectorAll('.js-filterLabel'),
      $activeFiltersContainer: document.querySelector('.js-filterActiveTags'),
      $clearFilters: component.querySelector('.js-filterClear'),
      $filterCount: component.querySelector('.js-filterCount'),
      $sortButtons: component.querySelectorAll('.js-filterSortOption'),
      $productGridEmpty: component.querySelector('.js-productGridEmpty'),
      $progressBarContainer: document.querySelector('[js-collection="progressBarContainer"]'),
      $progressBar: document.querySelector('[js-collection="progressBar"]'),
      $loadMoreButton: document.querySelector('[js-collection="loadMoreButton"]'),
    }
    this.state = {
      activeFilters: [],
      activeSort: new URL(document.location).searchParams.get('sort_by') || '',
      collectionHandle: this.dom.$component.dataset.collection,
      clearActiveClass: 'isActive',
      loadingProductsClass: 'loadingProducts',
      activeFilterClass: 'activeFilter',
      emptyGridClass: 'noProducts',
      nextUrl: this.dom.$productContainer.dataset.nextUrl,
      currentPage: Number(this.dom.$productContainer.dataset.currentPage),
      productTotalCount: this.dom.$productContainer.dataset.productTotalCount,
    }

    this.filterClickHandler = this.filterClick.bind(this)
    this.removeFilterHandler = this.removeFilter.bind(this)
    this.clearFiltersHandler = this.clearFilters.bind(this)
    this.sortSelectHandler = this.sortSelect.bind(this)
    this.popStateHandler = this.popState.bind(this)
    this.getProductsHandler = this.getProducts.bind(this)
    this.storePreviousUrlProductIdHandler = this.storePreviousUrlProductId.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom, state } = this
    dom.$filters.forEach(($filter) => $filter.addEventListener('change', this.filterClickHandler))
    dom.$clearFilters.addEventListener('click', this.clearFiltersHandler)
    dom.$sortButtons.forEach(($button) => $button.addEventListener('click', this.sortSelectHandler))
    window.addEventListener('popstate', this.popStateHandler)
    this.setActiveFilters()
    this.mountActiveFilterBtns()
    this.viewedCount()
    this.viewedTotalCount()
    this.progressBar()
    dom.$loadMoreButton.addEventListener('click', this.getProductsHandler)
    window.addEventListener('load', this.storePreviousUrlProductIdHandler)
    this.triggerCachedData()

    if (state.activeFilters.length > 0) {
      this.setEmptyGrid()
    }
  }

  setActiveFilters() {
    const { dom, state } = this
    const url = new URL(document.location)
    const urlTags = url
      .pathname
      .split(`/collections/${state.collectionHandle}`)[1]
      .replace('/', '')
      .split('+')
      .filter((str) => str.length > 0)

    state.activeFilters = urlTags.map((tag) => {
      const filterInput = dom.$component.querySelector(`.js-filterCheckbox[value="${tag}"]`)
      return {
        category: filterInput.dataset.categoryName,
        value: filterInput.value,
      }
    })
  }

  mountActiveFilterBtns() {
    const activeFilterBtns = document.querySelectorAll('.js-filterActiveBtn')
    activeFilterBtns.forEach((btn) => btn.addEventListener('click', this.removeFilterHandler))
  }

  filterClick(e) {
    const { dom, state } = this
    const filter = {
      category: e.target.dataset.categoryName,
      value: e.target.value,
    }
    const index = state.activeFilters.findIndex((activeFilter) => activeFilter.category === filter.category)

    if (index > -1) {
      this.replaceFilter(filter, index)
    } else {
      dom.$component.querySelector(`.js-filterLabel[for="${filter.value}"]`).classList.add(state.activeFilterClass)
      state.activeFilters.push(filter)
    }

    this.setClearBtn()
    this.pushToHistory()
    this.getFilterResults()
  }

  setClearBtn() {
    const { dom, state } = this
    const activeFiltersLength = state.activeFilters.length
    dom.$filterCount.textContent = activeFiltersLength

    if (activeFiltersLength > 0) {
      dom.$clearFilters.classList.add(state.clearActiveClass)
    } else {
      dom.$clearFilters.classList.remove(state.clearActiveClass)
    }
  }

  removeFilter(e) {
    const { dom, state } = this
    const { value } = e.currentTarget.dataset
    state.activeFilters = state.activeFilters.filter((activeFilter) => activeFilter.value !== value)
    dom.$component.querySelector(`.js-filterLabel[for="${value}"]`).classList.remove(state.activeFilterClass)
    dom.$component.querySelector(`.js-filterCheckbox[value="${value}"]`).checked = false
    e.currentTarget.remove()
    this.setClearBtn()
    this.pushToHistory()
    this.getFilterResults()
  }

  replaceFilter({ value }, index) {
    const { dom, state } = this
    const activeFilter = state.activeFilters[index]

    if (activeFilter.value === value) {
      dom.$component.querySelector(`.js-filterLabel[for="${value}"]`).classList.remove(state.activeFilterClass)
      state.activeFilters.splice(index, 1)
      return
    }

    dom.$component.querySelector(`.js-filterCheckbox[value="${activeFilter.value}"]`).checked = false
    dom.$component.querySelector(`.js-filterLabel[for="${activeFilter.value}"]`).classList.remove(state.activeFilterClass)
    dom.$component.querySelector(`.js-filterLabel[for="${value}"]`).classList.add(state.activeFilterClass)
    activeFilter.value = value
  }

  clearFilters() {
    const { dom, state } = this
    state.activeFilters = []
    dom.$filters.forEach((input) => input.checked = false)
    dom.$labels.forEach((label) => label.classList.remove(state.activeFilterClass))
    dom.$activeFiltersContainer.innerHTML = ''
    this.setClearBtn()
    this.pushToHistory()
    this.getFilterResults()
  }

  async getFilterResults(page = 1) {
    const { dom, state } = this
    let url = this.getFilteredUrl()

    if (page > 1) {
      url += url.includes('?') ? '&' : '?'
      url += `page=${page}`
    }

    try {
      const response = await axios.get(url)
      const page = document.createElement('html')
      page.innerHTML = response.data
      const pageProductGrid = page.querySelector('.js-productGrid')
      const pageActiveFilters = page.querySelector('.js-filterActiveTags')
      const pagePagination = page.querySelector('.js-pagination')
      const marketingBlock = page.querySelector('.js-marketingBlock')
      const mountCards = new Event('mountproductcards')

      dom.$productContainer.classList.add(state.loadingProductsClass)
      dom.$productContainer.innerHTML = pageProductGrid.innerHTML
      dom.$activeFiltersContainer.innerHTML = pageActiveFilters.innerHTML
      dom.$paginationContainer.innerHTML = pagePagination.innerHTML

      const newUrl = pageProductGrid.dataset.nextUrl
      const currentPage = Number(pageProductGrid.dataset.currentPage)
      state.nextUrl = newUrl
      state.currentPage = currentPage

      this.setEmptyGrid()
      document.dispatchEvent(mountCards)
      this.mountActiveFilterBtns()

      this.viewedCount()
      state.productTotalCount = pageProductGrid.dataset.productTotalCount
      this.viewedTotalCount()
      this.progressBar()
      window.scrollTo(0, 0)
      sessionStorage.removeItem(`cnvs-collection-data-${state.collectionHandle}`)
      this.storeProductCard(pageProductGrid.innerHTML, state.currentPage)
      this.storePreviousUrlProductId()

      if (marketingBlock) {
        this.loadMarketingContent()
      }

      dom.$productContainer.classList.remove(state.loadingProductsClass)
    } catch (e) {
      console.log('Error fetching filter results', e)
    }
  }

  setEmptyGrid() {
    const { dom, state } = this
    const productCards = document.querySelectorAll('.js-productCardContainer')

    if (productCards.length === 0) {
      dom.$productContainer.classList.add(state.emptyGridClass)
      dom.$productGridEmpty.classList.add(state.emptyGridClass)
    } else {
      dom.$productContainer.classList.remove(state.emptyGridClass)
      dom.$productGridEmpty.classList.remove(state.emptyGridClass)
    }
  }

  setActiveFilterInputs() {
    const { dom, state } = this

    dom.$filters.forEach((filter) => {
      const { value } = filter
      const index = state.activeFilters.findIndex((activeFilter) => activeFilter.value === value)
      if (index > -1) {
        dom.$component.querySelector(`.js-filterLabel[for="${value}"]`).classList.add(state.activeFilterClass)
        filter.checked = true
      } else {
        dom.$component.querySelector(`.js-filterLabel[for="${value}"]`).classList.remove(state.activeFilterClass)
        filter.checked = false
      }
    })
  }

  loadMarketingContent() {
    const { dom } = this
    const videos = dom.$productContainer.querySelectorAll('.js-marketingVideo')
    const images = dom.$productContainer.querySelectorAll('.js-marketingImage')

    videos.forEach((video) => this.loadMarketingContentVideo(video))
    images.forEach((image) => this.loadMarketingContentImage(image))
  }

  async loadMarketingContentVideo(video) {
    const source = video.querySelector('source')
    const { src } = source.dataset
    source.setAttribute('src', src)
    video.load()
    await video.play()
    video.setAttribute('data-loaded', 'true')
  }

  async loadMarketingContentImage(image) {
    const { src } = image.dataset
    const img = new Image()
    img.src = src
    await new Promise((resolve) => img.onload = () => resolve())
    image.setAttribute('src', src)
    image.setAttribute('data-loaded', true)
  }

  sortSelect(e) {
    const { state } = this
    state.activeSort = e.currentTarget.dataset.value
    window.location.href = this.getFilteredUrl()
  }

  pushToHistory() {
    const { state } = this
    const url = this.getFilteredUrl()
    history.pushState({ activeFilters: state.activeFilters }, state.collectionHandle, url)
  }

  getFilteredUrl() {
    const { state } = this
    const tagFilters = state.activeFilters.map((activeFilter) => activeFilter.value).join('+')
    let url = getLocalURL(`/collections/${state.collectionHandle}/${tagFilters}`)

    if (state.activeSort) {
      url += `?sort_by=${state.activeSort}`
    }

    return url
  }

  popState(e) {
    const { state } = this
    const url = new URL(document.location)
    const page = parseInt(url.searchParams.get('page')) || 1

    if (e.state) {
      state.activeFilters = e.state.activeFilters
    } else {
      this.setEmptyGrid()
      this.setActiveFilters()
    }

    this.setActiveFilterInputs()
    this.setClearBtn()
    this.getFilterResults(page)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Filter = this
  }

  /**
   * Get products
   * - Query products from collection pages and append to products list
   */
  async getProducts() {
    const { dom, state } = this

    try {
      const response = await axios.get(state.nextUrl)
      const page = document.createElement('html')
      page.innerHTML = response.data
      const pageProductGrid = page.querySelector('.js-productGrid')
      const newUrl = pageProductGrid.dataset.nextUrl
      const currentPage = Number(pageProductGrid.dataset.currentPage)
      const mountCards = new Event('mountproductcards')

      if (state.nextUrl === '') {
        return
      }

      state.nextUrl = newUrl
      state.currentPage = currentPage
      dom.$productContainer.innerHTML += pageProductGrid.innerHTML
      document.dispatchEvent(mountCards)

      this.viewedCount()
      this.viewedTotalCount()
      this.progressBar()
      this.storeProductCard(pageProductGrid.innerHTML, state.currentPage)
      this.updateUrlParams(currentPage)
      this.storePreviousUrlProductId()
      this.getCollectionCachedData()
    } catch (error) {
      throw new Error(error)
    }
  }

  /**
   * Viewed count
   * - Update product viewed count
   */
  viewedCount() {
    const { dom, state } = this
    const productCards = document.querySelectorAll('.js-productCardContainer')
    const count = document.querySelector('[js-collection="productCount"]')

    if (!productCards || !count) {
      return
    }

    count.innerHTML = productCards.length

    // Hide load more button if product cards matches productTotalCount
    if (productCards.length == state.productTotalCount) {
      dom.$loadMoreButton.classList.add('is-hidden')
    } else {
      dom.$loadMoreButton.classList.remove('is-hidden')
    }
  }

  /**
   * Viewed total count
   * - Update product viewed total count
   */
  viewedTotalCount() {
    const { state } = this
    const element = document.querySelector('[js-collection="productTotalCount"]')

    if (!element) {
      return
    }

    element.innerHTML = state.productTotalCount
  }

  /**
   * Progress bar
   */
  progressBar() {
    const { dom, state } = this
    const count = document.querySelectorAll('.js-productCardContainer').length

    dom.$progressBar.style.background = '#000000'
    dom.$progressBar.style.width = `${(count / state.productTotalCount) * 100}%`
  }

  /**
   * Store product card
   * - product cards is stored in session storage when user clicks load more button
   */
  storeProductCard(productCards, currentPage) {
    const { state } = this
    let sessionStorageData = JSON.parse(sessionStorage.getItem(`cnvs-collection-data-${state.collectionHandle}`))
    sessionStorage.setItem('currentUrl', window.location.pathname)

    if (sessionStorageData) {
      sessionStorageData = {
        ...sessionStorageData,
        [currentPage]: productCards,
      }
      sessionStorage.setItem(`cnvs-collection-data-${state.collectionHandle}`, JSON.stringify(sessionStorageData))

      return
    }

    // Fallback
    sessionStorage.setItem(`cnvs-collection-data-${state.collectionHandle}`, JSON.stringify({ [currentPage]: productCards }))
  }

  /**
   * Get collection cached data
   * - Restore and mount product cards if more than 1 page is viewed via sessions storage
   */
  getCollectionCachedData() {
    const { dom, state } = this
    const sessionStorageData = JSON.parse(sessionStorage.getItem(`cnvs-collection-data-${state.collectionHandle}`))
    const sessionStorageUrl = sessionStorage.getItem('currentUrl')

    if (!sessionStorageData) {
      return
    }

    if (Object.keys(sessionStorageData).length === 1) {
      return
    }

    if (sessionStorageUrl != window.location.pathname) {
      return
    }

    const productCardsCachedData = Object.values(sessionStorageData).join('')
    const mountCards = new Event('mountproductcards')
    dom.$productContainer.innerHTML = productCardsCachedData
    this.viewedCount()
    this.progressBar()
    document.dispatchEvent(mountCards)
  }

  /**
   * Store previous URL and product ID when product cards is clicked
   */
  storePreviousUrlProductId() {
    const productGrid = document.querySelector('.js-productGrid')
    const productCards = productGrid.querySelectorAll('.ProductGrid__card')

    productCards.forEach(element => {
      element.addEventListener('click', () => {
        const productId = element.querySelector('[js-product-card="productCard"]').dataset.productId
        const currentUrl = new URL(window.location)

        const data = {
          selected_product_id: productId,
          previous_url: currentUrl,
        }

        sessionStorage.setItem('selected_product_id_and_previous_url', JSON.stringify(data))
      })
    })
  }

  /**
   * Trigger cache data
   * - Check for session storage previous URL matches current URL to get cached
   *   data to restore product cards. This instance will occur when user clicks
   *   on the browser back button
   */
  triggerCachedData() {
    const sessionDataObject = JSON.parse(sessionStorage.getItem('selected_product_id_and_previous_url'))
    const currentUrl = window.location.href

    if (currentUrl.includes('page')) {
      this.getCollectionCachedData()
      this.updateCollectionCachedData()
    }

    if (!sessionDataObject) {
      return
    }

    // Check if previous/current URL match and URL contains page param get cached date
    if (sessionDataObject.previous_url === currentUrl && currentUrl.includes('page')) {
      this.scrollToSelectedProductCard()
    }

    sessionStorage.removeItem('selected_product_id_and_previous_url')
  }

  /**
   * Update collection cached data
   * - Handles current page to load in the correct data. Check if current page
   *   aligns with session storage collection data, else remove and update data.
   *
   * - Example:
   *   Cache data contains page 1, 2, 3, 4 and current URL is viewing page 2 (?page=2),
   *   cache data is then updated to contain page 1, 2 only
   *
   */
  updateCollectionCachedData() {
    const { state } = this
    const sessionCollectionData = JSON.parse(sessionStorage.getItem(`cnvs-collection-data-${state.collectionHandle}`))
    const currentUrl = new URL(window.location)
    const params = new URLSearchParams(currentUrl.search)
    const currentPageNumber = Number(params.get('page'))

    if (!sessionCollectionData) {
      return
    }

    // Check if current page number don't match object keys in session collection data
    if (currentPageNumber != Object.keys(sessionCollectionData).length) {
      // Return object keys that is more then currentPageNumber
      const filterKeys = Object.keys(sessionCollectionData).filter((key) =>  {
        return key > currentPageNumber
      })

      // Remove additional data
      for (var i = 0; i < filterKeys.length; i++) {
        delete sessionCollectionData[filterKeys[i]];
      }

      // Update collection data
      sessionStorage.setItem(`cnvs-collection-data-${state.collectionHandle}`, JSON.stringify(sessionCollectionData))
    }
  }

  /**
   * Scroll to selected product card
   */
  scrollToSelectedProductCard() {
    const sessionDataObject = JSON.parse(sessionStorage.getItem('selected_product_id_and_previous_url'))

    if (!sessionDataObject) {
      return
    }

    const productCard = document.getElementById(`product-card-${sessionDataObject.selected_product_id}`)

    productCard.scrollIntoView()
  }

  /**
   * Update URL params
   * @param {number} - Page number
   */
  updateUrlParams(currentPage) {
    const currentUrl = new URL(window.location)

    currentUrl.searchParams.set('page', currentPage)
    window.history.replaceState({}, '', currentUrl)
  }
}
